import { I18n } from 'aws-amplify'

const Strings = () => ({
  organization: I18n.get('Organization'),
  selectDefault: I18n.get('Please Select')
})

export default Strings
